import { Box, Button, Dialog, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    backgroundColor: '#FAFCFF',
    minWidth: '900px',
    '&::-webkit-scrollbar': {
      width: '12px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    '&::-webkit-scrollbar-track': {
      margin: '6px 0',
    },
  },
}));

export const DialogContainer = styled(Box)(() => ({
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
}));

export const CriteriasListBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  margin: '0 8px 20px',
}));

export const TextTypography = styled(Typography)(() => ({
  fontSize: '18px',
  fontWeight: '500',
  marginBottom: 8,
}));

export const UploadBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '20px',
  alignItems: 'center',
  padding: '24px',
  margin: '0 8px 40px',
  borderRadius: '12px',
  border: '0.5px solid #8B8C8E',
}));

export const CriteriaText = styled(Typography)(() => ({
  width: '100%',
  fontSize: '18px',
  textAlign: 'left',
}));

export const OutlineButton = styled(Button)(({ theme }) => ({
  width: '180px',
  backgroundColor: 'transparent',
  borderRadius: '8px',
  color: theme.palette.secondary.light,
  border: `1px solid ${theme.palette.secondary.light}`,
  gap: '6px',
  span: {
    fontWeight: 600,
    fontSize: '21px',
  },
  '&:hover': {
    backgroundColor: theme.palette.secondary.light,
  },
  '&:disabled': {
    color: theme.palette.secondary.light,
  },
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  width: '180px',
  backgroundColor: theme.palette.secondary.light,
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
}));
